<script setup>
/*
 * Hvor mange butikker foelger vi paa varen.
 *
 * Blokken siger baade hvad vi HAR og hvad vi ikke ved. Den maa ikke
 * laese som en paastand om at vi daekker alt.
 */
import { computed } from 'vue';

const props = defineProps({
    data: { type: Object, required: true },
});

const butikker = computed(() => props.data.butikker || []);

function kr(v) {
    const n = Number(v);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 }).format(n);
}
</script>

<template>
    <p v-if="!data.vare" class="text-secondary small mb-0">
        Ingen vare valgt.
    </p>

    <div v-else class="daekning">
        <p class="mb-2">
            Vi følger prisen på <strong>{{ data.vare.navn }}</strong> hos
            <strong>{{ data.antal }}</strong>
            {{ data.antal === 1 ? 'butik' : 'butikker' }}.
        </p>

        <ul v-if="butikker.length" class="list-unstyled mb-2">
            <li v-for="(b, i) in butikker" :key="i" class="d-flex justify-content-between border-bottom py-1">
                <span>{{ b.navn }}</span>
                <span class="fw-semibold">{{ kr(b.pris) }}</span>
            </li>
        </ul>

        <p class="small text-secondary mb-0">
            Vi henter priser fra {{ data.butikkerIAlt }} danske butikker, men vi dækker ikke alle
            forhandlere i landet. Er der en butik du savner, er den sandsynligvis ikke med —
            ikke at den er dyrere.
        </p>
    </div>
</template>
